import React from 'react'
import SectionContainer from '../../../Homepage/SectionContainer'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import { Col, Container, Row } from 'reactstrap';
import aboutImg from "../../../assets/kangaroo/aboutUsWeb.webp"
import TimerModal from '../../../component/TimerModal/TimerModal';
import "../About.css"
const About = () => {

  return (
    <SectionContainer>
      <Container fluid>
        <Row>
          <Col >
            <BreadCrumb items={[
              { title: "HOME", link: "/" },
              { title: "ABOUT", link: "/" },
              { title: "CEO" },
            ]} instituition={false} className="" />
          </Col>
        </Row>
        <Row>
          <Col>
            <h1 className='font-level-4 lh-1 mt-3' style={{ marginBottom: "4.5rem" }}>MESSAGE FROM <br /> FOUNDER & CEO</h1>
          </Col>
        </Row>
        <Row className='align-items-center '>
          <Col lg={6} sm={12}><img src={aboutImg} className="w-100 h-100 mb-5" alt="" fluid /></Col>
          <Col lg={6} sm={12}>

            <p className='about-intro-font '>
              From Nepal to the global education ecosystem, Kangaroo Education Foundation was built on one simple belief: every student deserves honest guidance and realistic opportunities. Our commitment to authentic COUNSELING, ethical practice, and long-term student success has shaped who we are today. We exist to prepare students with clarity, confidence, and purpose - before guiding them toward their global ambitions.</p></Col>
        </Row>
        <Row  >
          <Col style={{ marginTop: "clamp(2.5rem,6vw,6.7rem)", marginBottom: "18rem" }}>
            <p className='country-paragraph-text '>I warmly welcome all students and families who aspire to pursue international education and build meaningful global careers. At <span className='fw-bold'>Kangaroo Education Foundation</span>, our journey began with a clear purpose - to guide students from Nepal with honesty, clarity, and responsibility as they navigate important decisions about their future.
              <br /> <br />
              Over the years, we have built strong and trusted relationships with universities and colleges worldwide, enabling us to connect students with opportunities that truly align with their academic potential and career aspirations. Our focus has always been on opening new horizons of knowledge while ensuring that students are well-prepared, well-informed, and confident in the choices they make.
              <br /> <br />
              KEF was established with the genuine objective of supporting students in their pursuit of higher education. <span className='fw-bold'>Authentic and genuine COUNSELING</span> remains the foundation of our work. We place the highest importance on integrity, reliability, and accountability, and we believe that ethical guidance is the cornerstone of long-term success. To uphold these principles, we work with trained professionals and experienced counsellors who provide accurate, transparent, and practical advice tailored to each student’s individual goals.
              <br /> <br />
              From our base in Nepal, we have extended our support through onshore offices in <span className='fw-bold'>Sydney, Adelaide, and Tasmania</span>, ensuring continuity of care for students even after they commence their studies. This presence allows us to support students not only at the planning stage, but throughout their academic journey - from enrolment and compliance to practical on-ground assistance.
              <br /> <br />
              I firmly believe that success favours those who are prepared. At KEF, we focus first on preparation - through structured test preparation, careful course and institution selection, accurate documentation, and clear guidance - before helping students move confidently toward their dreams. Our services are designed to offer a comprehensive support system, covering test preparation, admissions, visa processes, and essential student services, all delivered with responsibility and care.
              <br /> <br />
              It gives me great pride to see our students grow, succeed, and represent Nepal on global platforms. I invite you to engage with Kangaroo Education Foundation and allow us to be a trusted partner in your journey. Together, we can lay strong foundations and build futures shaped by knowledge, opportunity, and integrity.
              <br /> <br />
              <span className='fw-bold'>Mahesh Babu Timalsina</span> <br />
              Founder & CEO
            </p>
          </Col>
        </Row>

      </Container>
    </SectionContainer>
  )
}

export default About
